import React from "react";
import { motion } from "framer-motion";
import { FaMusic, FaCalendarAlt } from "react-icons/fa";

const InstrumentPage = () => {
  return (
    <div className="relative min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-100 flex flex-col items-center justify-center px-6 py-20 text-center">
      {/* Floating background accents */}
      <div className="absolute inset-0 overflow-hidden">
        <motion.div
          className="absolute w-72 h-72 bg-blue-200 rounded-full top-10 left-10 opacity-20 blur-2xl"
          animate={{ scale: [1, 1.1, 1], opacity: [0.2, 0.3, 0.2] }}
          transition={{ repeat: Infinity, duration: 7 }}
        ></motion.div>
        <motion.div
          className="absolute w-96 h-96 bg-blue-300 rounded-full bottom-10 right-10 opacity-20 blur-2xl"
          animate={{ scale: [1, 1.05, 1], opacity: [0.2, 0.25, 0.2] }}
          transition={{ repeat: Infinity, duration: 9 }}
        ></motion.div>
      </div>

      {/* Main Card */}
      <motion.div
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="relative bg-white rounded-3xl shadow-2xl border-2 border-blue-400 p-10 max-w-3xl z-10"
      >
        <FaMusic className="text-blue-500 text-6xl mx-auto mb-4" />
        <h1 className="text-4xl font-extrabold text-blue-600 mb-4">
          🎼 ¡Partituras Disponibles Pronto!
        </h1>
        <p className="text-lg md:text-xl text-gray-700 mb-6">
          Todas las partituras oficiales se publicarán el:
        </p>
        <p className="text-2xl font-bold text-blue-500 mb-4">
          1 de Enero de 2026
        </p>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="bg-blue-50 border border-blue-200 rounded-xl p-6 shadow-inner mb-6"
        >
          <div className="flex items-center justify-center mb-3">
            <FaCalendarAlt className="text-blue-500 text-2xl mr-2" />
            <h2 className="text-xl font-semibold text-blue-600">
              ¡Marca la Fecha!
            </h2>
          </div>
          <p className="text-gray-700">
            Estamos preparando el material para que puedas descargar todas las
            partituras y comenzar a ensayar. ¡No te lo pierdas!
          </p>
        </motion.div>

        <p className="text-gray-700 text-sm">
          Mantente pendiente de esta página para ver las partituras
          instrumentales cuando sean liberadas.
        </p>
      </motion.div>
    </div>
  );
};

export default InstrumentPage;

/*
import React from 'react';
import { motion } from 'framer-motion';

const InstrumentPage = () => {
  // Mapping of each instrument to its specific Google Drive folder link.
  const instrumentFolders = {
    "Violin I": "https://drive.google.com/drive/folders/1Ml3YF9192Ah2D-yT8bZTqorHBJbuR62B?usp=sharing",
    "Violin II": "https://drive.google.com/drive/folders/1yeX12_QG8pK7rI4Lik2Xn8dM-XexT08M?usp=sharing",
    "Viola": "https://drive.google.com/drive/folders/1dWwiGMIXVW1svsjMCGDC1NT4J2s79NmV?usp=sharing",
    "Cello": "https://drive.google.com/drive/folders/1SMOTUVtVBqIrgdAdyxexcXK44Bxqb117?usp=sharing",
    "Bass": "https://drive.google.com/drive/folders/1c0EIIdCjayQ02f5CS8Y_HrM6eaetjJNA?usp=share_link",
    "Flute": "https://drive.google.com/drive/folders/1_e6dr6Hu_W5pBaYMp_euMVP_fic1FH41?usp=sharing",
    "Clarinet": "https://drive.google.com/drive/folders/1H50VwGSnSQYZ4Ptl35yFbZinKIrJQA8U?usp=sharing",
    "Oboe": "https://drive.google.com/drive/folders/1SUfrHfzkSgj7cPJVEW-UCZyLh7rlQ_75?usp=sharing",
    "Bassoon": "https://drive.google.com/drive/folders/1Hdk0AmBnygPeKOCqEmwJ-SJfwda3bo5F?usp=sharing",
    "Trumpet": "https://drive.google.com/drive/folders/1KJn67-D3qr7S8chOxgte0V9A8nYxL0Tx?usp=sharing",
    "Trombone": "https://drive.google.com/drive/folders/1b4L14Kd7cT028T61xlJ4FzkyP5BJ9bxM?usp=sharing",
    "Horn": "https://drive.google.com/drive/folders/1kQhgdDOx-XKvP8iaI5G_DZItOV9pDYJZ?usp=sharing",
    "Tuba": "https://drive.google.com/drive/folders/1ei7lbVjqUsw2YRl25LIOxyuzFb58RnK6?usp=sharing",
    "Percussion": "https://drive.google.com/drive/folders/1iu1VTL0OumgQhAE7-NHYY1PDLLJJh_Sk?usp=sharing",
    "Harp": "https://drive.google.com/drive/folders/your_harp_folder_link?usp=share_link",
    "Piano": "https://drive.google.com/drive/folders/1iu1VTL0OumgQhAE7-NHYY1PDLLJJh_Sk?usp=sharing",
  };

  // Extract instruments as an array for mapping.
  const instruments = Object.keys(instrumentFolders);

  return (
    <div className="bg-[#101827] min-h-screen py-10">
      <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-lg">
        <h1 className="text-3xl font-bold mb-6 text-center text-gray-900">
          Instrument Sheet Music
        </h1>
        <p className="text-gray-700 mb-8 text-center">
          Click on an instrument below to view the corresponding sheet music on Google Drive.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {instruments.map((instrument) => (
            <motion.a
              key={instrument}
              href={instrumentFolders[instrument]}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="block bg-blue-600 text-white px-4 py-3 rounded text-center transition-colors hover:bg-blue-700"
            >
              {instrument}
            </motion.a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InstrumentPage;
*/
